import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payroll-authorize-grid',
  templateUrl: './payroll-authorize-grid.component.html',
  styleUrls: ['./payroll-authorize-grid.component.css']
})
export class PayrollAuthorizeGridComponent implements OnInit {
  title="Payroll Approval";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/payroll-authorize/payroll-authorize-grid/payroll-authorize-grid.component.ts